var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardGraph',{attrs:{"barChart":"true","color":_vm.color,"icons":_vm.icons,"title":_vm.title,"load_url":_vm.load_url}})}
var staticRenderFns = []

export { render, staticRenderFns }